// extracted by mini-css-extract-plugin
export default {"hr":"HR-module--hr--f447a"};